export enum ApprovalFlowStatus {
  Waiting = 0,
  InProgress = 1,
  Approved = 2,
}
